<!--
  elIcon.vue - Simplified Sprite-Based Icon Component

  EXTRACTED FROM MEZMO: /projects/logdna-web/packages/@ui/components/src/components/Icon.vue
  Original Lines: ~200 lines (complex component with runtime SVG loading)
  Simplified to: ~50 lines (sprite-based pattern)

  SPRITE PATTERN vs ORIGINAL:
    - Original: Dynamic SVG loading, inline SVG injection, complex caching
    - This version: Simple <use> reference to sprite symbols
    - Sprite location: /icons-sprite.svg (generated from individual SVGs)
    - SVG symbols: <symbol id="icon-{name}"> in sprite file

  USAGE:
    <elIcon name="pulse" size="lg" color="#dce0e3" />

  PROPS:
    - name (required): Icon name matching sprite symbol (e.g., "pulse" → #icon-pulse)
    - size (optional): sm (16px), md (20px), lg (24px), xl (32px)
    - color (optional): CSS color value (default: currentColor)

  SIMPLIFICATION RATIONALE:
    - Sprite pattern is simpler and more performant
    - No runtime SVG fetching or parsing
    - Browser caching works automatically
    - Easier to debug (just check sprite file)
    - Mezmo's original complexity not needed for this use case

  ACCESSIBILITY:
    - aria-label set to icon name
    - Semantic <svg> element
    - Color contrast handled by caller
-->
<template>
  <svg
    :width="sizeStyle"
    :height="sizeStyle"
    :style="{ color }"
    class="icon"
    :aria-label="name"
  >
    <use :href="iconHref" />
  </svg>
</template>

<script setup>
import { computed } from 'vue'

// Use Vite's base path for icon sprite
const BASE_URL = import.meta.env.BASE_URL

const props = defineProps({
  name: {
    type: String,
    required: true
  },
  size: {
    type: String,
    default: 'md',
    validator(value) {
      return ['sm', 'md', 'lg', 'xl'].includes(value)
    }
  },
  color: {
    type: String,
    default: 'currentColor'
  }
})

const iconHref = computed(() => {
  return `${BASE_URL}icons-sprite.svg#icon-${props.name}`
})

const sizeStyle = computed(() => {
  const sizes = {
    sm: '16px',
    md: '20px',
    lg: '24px',
    xl: '32px'
  }
  return sizes[props.size] || sizes.md
})
</script>

<style scoped>
.icon {
  display: inline-block;
  vertical-align: middle;
}
</style>
